__turbopack_context__.v({
  "image-view-mode": "EmailSignatureEditorImageViewMode-module-scss-module__4pmwfW__image-view-mode",
  "image-view-mode-btns-container": "EmailSignatureEditorImageViewMode-module-scss-module__4pmwfW__image-view-mode-btns-container",
  "image-view-mode-container": "EmailSignatureEditorImageViewMode-module-scss-module__4pmwfW__image-view-mode-container",
  "image-view-mode-holder": "EmailSignatureEditorImageViewMode-module-scss-module__4pmwfW__image-view-mode-holder",
});
